import React from 'react';
import { useWallet } from '@solana/wallet-adapter-react';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';

const WalletConnectButton = ({ onWalletConnect }) => {
  const { publicKey, connected, disconnect } = useWallet();

  const handleDisconnect = () => {
    disconnect();
    if (onWalletConnect) {
      onWalletConnect(null);
    }
  };

  // Custom styling for the Oracle theme
  const walletButtonStyle = {
    background: 'linear-gradient(135deg, #000000 0%, #333333 100%)',
    border: 'none',
    borderRadius: '10px',
    color: 'white',
    fontFamily: 'JetBrains Mono, monospace',
    fontSize: '1rem',
    fontWeight: '500',
    padding: '15px 30px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    minWidth: '200px',
  };

  return (
    <div className="wallet-connect-container">
      {connected ? (
        <div className="wallet-connected header-wallet-connected">
          <div className="wallet-info">
            <span className="wallet-address">
              {publicKey?.toString().slice(0, 6)}...{publicKey?.toString().slice(-4)}
            </span>
          </div>
          <button 
            className="disconnect-btn"
            onClick={handleDisconnect}
            style={walletButtonStyle}
          >
            Disconnect
          </button>
        </div>
      ) : (
        <div className="wallet-connect">
          <WalletMultiButton 
            style={walletButtonStyle}
            className="oracle-wallet-button"
          />
        </div>
      )}
    </div>
  );
};

export default WalletConnectButton; 